import PrimitiveShape from '../PrimitiveShape';

export default class WebGLLine extends PrimitiveShape {

	public constructor (private x1: number, private y1: number, private x2: number, private y2: number) {
		super(WebGL2RenderingContext.LINES, [
			x1, y1, 0, 1,
			x2, y2, 0, 1
		]);
	}

	/*
	 * Factory methods
	 */

	public static fromNumbers (x1: number, y1: number, x2: number, y2: number) {
		return new WebGLLine(x1, y1, x2, y2);
	}

	/*
	 * Query methods
	 */

	public copy () {
		return new WebGLLine(this.x1, this.y1, this.x2, this.y2).setColor(this.getColor()).setTransformationMatrix(this.getTransformationMatrix());
	}

	public getX1 () {
		return this.x1;
	}

	public getY1 () {
		return this.y1;
	}

	public getX2 () {
		return this.x2;
	}

	public getY2 () {
		return this.y2;
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/shapes/primitives/WebGLLine.ts